import {useEffect, useState} from "react";
import {findItemCategories} from "../api/itemCategoryApiClient";

export const useItemCategories = (reloadTrigger) => {
    const [itemCategories, setItemCategories] = useState([]);

    useEffect(() => {
        const abortController = new AbortController();

        findItemCategories(abortController.signal)
            .then(
                (data) => {
                    setItemCategories(data.itemCategories);
                }
            )
            .catch(
                (error) => console.log(error)
            );

        return () => {
            abortController.abort();
        };
    }, [reloadTrigger]);

    return {itemCategories : itemCategories};
};
